<div class="row mb-5">
  <div class="col-sm-2"></div>
  <div class="col-sm-5">Desktop</div>
  <!-- <div class="col-sm-5">Mobile</div> -->
</div>
<div class="row">
  <div class="col-sm-2 typography-type mb-5">Headings</div>
  <div class="col-sm-5">
    <div class="typography-title">
      <p>Title (H1)</p>
      <p>Nunito Sans Bold, 32px, line-height 40px</p>
    </div>
    <h1 class="h1">All your activities in one place</h1>
    <div class="typography-title">
      <p>Heading (H2)</p>
      <p>Nunito Sans Bold, 24px, line-height 32px</p>
    </div>
    <h2 class="h2">Start working on your sustainability communication</h2>
    <div class="typography-title">
      <p>Heading (H3)</p>
      <p>Nunito Sans Bold, 18px, line-height 24px</p>
    </div>
    <h3 class="h3">Increase internal and external stakeholder engagement</h3>
    <div class="typography-title">
      <p>Overline (H4)</p>
      <p>Nunito Sans Bold, MakeUpperCase, 14px, line-height 24px</p>
    </div>
    <h4 class="h4">Stakeholder Engagement</h4>
  </div>
  <div class="col-sm-5"></div>
</div>

<div class="row">
  <div class="col-sm-2 typography-type mb-5">Body</div>
  <div class="col-sm-5">
    <div class="typography-title">
      <p>Lead</p>
      <p>Nunito Sans Regular, 20px, line-height 24px</p>
    </div>
    <p class="lead">Manage your sustainability data with ease and share your achievements with the world.</p>
    <div class="typography-title">
      <p>Body</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="body">
      Centralising all your activities makes it so much simpler to measure your progress. Plus, you'll reduce your corporate sustainability management and
      reporting costs.
    </p>
    <div class="typography-title">
      <p>Body Bold</p>
      <p>Nunito Sans Bold, 16px, line-height 24px</p>
    </div>
    <p class="body-bold">Centralising all your activities makes it so much simpler to measure your progress.</p>
  </div>
  <div class="col-sm-5"></div>
</div>

<div class="row">
  <div class="col-sm-2 typography-type mb-5">Fields &amp; Graphs</div>
  <div class="col-sm-5">
    <div class="typography-title">
      <p>Caption</p>
      <p>Nunito Sans Regular, 14px, line-height 24px</p>
    </div>
    <p class="caption">Email template</p>
    <div class="typography-title">
      <p>Caption Bold</p>
      <p>Nunito Sans Regular, 14px, line-height 24px</p>
    </div>
    <p class="caption-bold">Email template</p>
    <div class="typography-title">
      <p>Input Value</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="input-value">Water consumption reduction by 2025</p>
    <div class="typography-title">
      <p>Top Number</p>
      <p>Nunito Sans Regular, 32px, line-height 40px</p>
    </div>
    <p class="top-number">24.547</p>
    <div class="typography-title">
      <p>Table Value</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="table-value">Water consumption reduction by 2025</p>
    <div class="typography-title">
      <p>Table Value Bold</p>
      <p>Nunito Sans Bold, 16px, line-height 24px</p>
    </div>
    <p class="table-value-bold">Water consumption reduction by 2025</p>
  </div>
  <div class="col-sm-5"></div>
</div>

<div class="row">
  <div class="col-sm-2 typography-type mb-5">Navigation</div>
  <div class="col-sm-5">
    <div class="typography-title">
      <p>Navigation</p>
      <p>Nunito Sans Regular, 14px, line-height 24px</p>
    </div>
    <p class="navigation">Results&emsp;Feedback management&emsp;Flow editor&emsp;Distribution</p>
    <div class="typography-title">
      <p>Button Bold</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="button-bold">Save</p>
    <div class="typography-title">
      <p>Button Regular</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="button-regular">Save</p>
    <div class="typography-title">
      <p>Button Text</p>
      <p>Nunito Sans Regular, 16px, line-height 24px</p>
    </div>
    <p class="button-text">+ Add account</p>
  </div>
  <div class="col-sm-5"></div>
</div>
